var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10.9283 10 11.8185 9.63125 12.4749 8.97487C13.1313 8.3185 13.5 7.42826 13.5 6.5C13.5 5.57174 13.1313 4.6815 12.4749 4.02513C11.8185 3.36875 10.9283 3 10 3C9.07174 3 8.1815 3.36875 7.52513 4.02513C6.86875 4.6815 6.5 5.57174 6.5 6.5C6.5 7.42826 6.86875 8.3185 7.52513 8.97487C8.1815 9.63125 9.07174 10 10 10ZM5.75 11C5.28587 11 4.84075 11.1844 4.51256 11.5126C4.18437 11.8408 4 12.2859 4 12.75V13C4 14.1965 4.7615 15.2085 5.8425 15.8965C6.9295 16.5885 8.401 17 10 17C11.599 17 13.07 16.5885 14.1575 15.8965C15.2385 15.2085 16 14.1965 16 13V12.75C16 12.2859 15.8156 11.8408 15.4874 11.5126C15.1592 11.1844 14.7141 11 14.25 11H5.75Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconName);
export default __webpack_public_path__ + "static/media/icon-name.35c7b7a3ff4d2074a1f23ec07d4dcba1.svg";
export { ForwardRef as ReactComponent };